<template>
  <div class="bm-image-thumbnail">
    <img class="bm-image-thumbnail" :src="getImageUrl(src)" @click="fireSelectEvent(src)"/>
    <i class="bm-image-thumbnail el-icon-delete" @click="fireRemoveEvent(src)"></i>
  </div>
</template>

<script>
export default {
  name: 'ImageThumbnail',
  props: {
    src: {
      type: String
    }
  },
  methods: {
    getImageUrl: function (url) {
      return process.env.VUE_APP_IMG_ORIGIN + url
    },
    fireRemoveEvent: function (src) {
      this.$emit('remove', src)
    },
    fireSelectEvent: function (src) {
      this.$emit('select', src)
    }
  }
}
</script>

<style scoped>
div.bm-image-thumbnail {
  display: inline-block;
  position: relative;
  margin: 5px;
  border: solid 1px gray;
  border-radius: 5px;
  width: 46px;
  height: 46px;
}
div.bm-image-thumbnail:hover img.bm-image-thumbnail {
  filter: brightness(60%);
}
img.bm-image-thumbnail {
  width: 46px;
  height: 46px;
  border-color: gray;
  border-radius: 5px;
}
i.bm-image-thumbnail {
  display: none;
  color: white;
}
div.bm-image-thumbnail:hover i.bm-image-thumbnail {
  display: inline-block;
  position: absolute;
  top: 3px;
  left: 28px;
}
</style>
